export default __webpack_public_path__ + "static/media/Rubik-Light.7ee66bf7.ttf";